import styled from 'styled-components';
import { SWEGON_GREEN, WHITE } from '@swegon-core/uic/dist/src/theme';

export const AHUDLiteTempText = styled.h2`
    margin: 10px 10px 10px 10px;
    display: inline-flex;
    top: 200px;
    left: 50%;
    text-align: center;
    position: fixed;
    transform: translate(-50%, -50%);
`;

export const ContentContainerOLD = styled.div`
    width: 100%;
    height: calc(100vh - 5px);
    margin: 8px 26px 12px 26px;
    display: inline-grid;
    column-gap: 12px;
    grid-template-columns: 60% 35%;
`;

export const ContentContainer = styled.div`
    width: calc(100vw - 50px);
    height: calc(100vh - 98px);
    margin: 8px 24px 12px;
    display: inline-grid;
    column-gap: 12px;
    grid-template-columns: 1.5fr 1fr;
    overflow-y: auto;
`;

export const LeftContainer = styled.div`
    background-color: ${WHITE};
    padding: 1rem;
    display: flex;
    flex-direction: column;
`;

export const RightContainer = styled.div`
    background-color: ${WHITE};
    padding: 1rem;
    display: grid;
`;

export const PrintLoading = styled.div`
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 20px;
    height: 20px;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: center;
    border: 2px solid ${SWEGON_GREEN};
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;
